import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { ModalController } from '@ionic/angular';


@Component({
  selector: 'app-modal-show-files',
  templateUrl: './modal-show-files.component.html',
  styleUrls: ['./modal-show-files.component.scss']
})
export class ModalShowFilesComponent implements OnInit {
  @Input() selectedImage: any;
  @Input() imageList: any[] = [];
  @Input() otherFiles: any[] = [];

  constructor(
    private modalCtrl: ModalController,
  ) { }

  currentImageIndex = 0;
  currentDocStartIndex = 0;
  visibleCount = 3;

  ngOnInit() {
    
  }

  scrollLeft(el: HTMLElement) {
    el.scrollBy({ left: -220, behavior: 'smooth' });
  }

  scrollRight(el: HTMLElement) {
    el.scrollBy({ left: 220, behavior: 'smooth' });
  }



  previousImage() {
    if (this.currentImageIndex > 0) {
      this.currentImageIndex--;
    }
  }

  nextImage() {
    if (this.currentImageIndex < this.imageList.length - 1) {
      this.currentImageIndex++;
    }
  }



  get visibleDocs(): string[] {
    return this.otherFiles.slice(
      this.currentDocStartIndex,
      this.currentDocStartIndex + this.visibleCount
    );
  }

  previousDocs() {
    if (this.currentDocStartIndex >= this.visibleCount) {
      this.currentDocStartIndex -= this.visibleCount;
    } else {
      this.currentDocStartIndex = 0;
    }
  }

  nextDocs() {
    if (this.currentDocStartIndex + this.visibleCount < this.otherFiles.length) {
      this.currentDocStartIndex += this.visibleCount;
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm() {
    return this.modalCtrl.dismiss(null, 'confirm');
  }

  downloadCurrentImage(): void {
  const url = this.imageList[this.currentImageIndex];
  const link = document.createElement('a');
  link.href = url;
  link.download = `imagem-${this.currentImageIndex + 1}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

downloadDoc(doc: File): void {
  const url = URL.createObjectURL(doc);
  const link = document.createElement('a');
  link.href = url;
  link.download = doc.name || 'documento';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}


}
